import {
  LayoutOptions,
  NavWidgetBlockType,
  processLayoutOptions,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

enum TestOptions {
  SomeOption = "optionA",
  AnotherOption = "optionB",
}
export const layoutOptions = Object.assign(LayoutOptions.BackgroundColor, {
  SomeOptions: LayoutOptions.Options(TestOptions),
  yesOrNo: LayoutOptions.Boolean,
  pickANumber: LayoutOptions.Range(1, 1999),
});

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type PlaceholderType = {
  /** Place prop documentation here */
  text: string;
} & NavWidgetBlockType<LayoutProps>;
